import type { FaireProductEntity } from "../../entity_types/product";

export const p_9h5vxx96ca: FaireProductEntity = {
  token: "p_9h5vxx96ca",
  type: "product",
  name: "Checkered Sling Bag - Cloud",
  brandToken: "b_4f1f7699",
  brandName: "Anchal",
  imageUrl: "https://cdn.faire.com/fastly/6f48031363e7263cc79281d7bbb20e6acb908c8d731585dee25f5f332527f200.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1a0484128e4f4a1336b71755e8a4f7eb52bbc13c55163627d2077f8d005ed695.jpeg",
    "https://cdn.faire.com/fastly/ed2f63fb39d9bb33b30b3996c62c9b5dd234fa29453dd369f126385208c3531d.jpeg",
    "https://cdn.faire.com/fastly/5af45b1973c85cd7124adcd9a2319f5890f72fedf4dbb4cc7336e18c71cbc78a.jpeg",
    "https://cdn.faire.com/fastly/2e5714a24dcc7760f9273989e5b654f67017aeeb6280f39994efe37f9b97da7d.jpeg"
  ],
  priceDollars: 28,
  description: "Phone, wallet, keys? Check. Meet your new everyday essential. Our Checkered Sling Bag in Cloud is crafted from durable cotton canvas and features a colorful, embroidered checkered pattern that adds a playful pop to any outfit. Designed with a secure zippered compartment and an adjustable strap, it’s made to be worn comfortably across the chest or over the shoulder—keeping your essentials close and your hands free.\n\nProduct Details:\n• Size: 15\"L x 4\"W x 8\"H - 50\" fully extended strap length\n• Materials: 1 layer of 100% organic cotton twill, canvas-lined interior, lead-free YKK gold-tone metal zipper closure, durable black plastic buckle hardware\n• Featuring: 1 main zippered compartment, 1 interior slip pocket\n• Dyed with non-toxic & low-impact AZO-free dyes\n• Handcrafted by a skilled woman artisan in Ajmer, India\n• Features the hand-stitched signature of the maker on the tag",
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:51.797Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
